var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 80,
    rx: 15,
    fill: "#6D35C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 9C23.8725 9 10 23.0031 10 40.2744C10 54.0951 18.8815 65.8151 31.1962 69.946C32.7462 70.2405 33.3146 69.2736 33.3146 68.4422C33.3146 67.6994 33.2887 65.7317 33.2758 63.1255C24.6527 65.0124 22.834 58.9296 22.834 58.9296C21.4235 55.32 19.3852 54.3557 19.3852 54.3557C16.5772 52.4167 19.6023 52.4558 19.6023 52.4558C22.7152 52.6747 24.3504 55.677 24.3504 55.677C27.1146 60.4594 31.607 59.0781 33.3792 58.278C33.6582 56.2556 34.4564 54.8769 35.3425 54.0951C28.4579 53.3132 21.222 50.6236 21.222 38.6403C21.222 35.2262 22.4232 32.4375 24.4124 30.2483C24.0637 29.4587 23.0174 26.2791 24.6837 21.9711C24.6837 21.9711 27.2799 21.1319 33.2087 25.1767C35.6887 24.4808 38.3237 24.1368 40.9587 24.1212C43.5937 24.1368 46.2287 24.4808 48.7087 25.1767C54.5987 21.1319 57.1949 21.9711 57.1949 21.9711C58.8612 26.2791 57.8149 29.4587 57.5049 30.2483C59.4812 32.4375 60.6824 35.2262 60.6824 38.6403C60.6824 50.6549 53.4362 53.3002 46.5387 54.069C47.6237 55.0072 48.6312 56.9254 48.6312 59.8548C48.6312 64.0403 48.5924 67.4023 48.5924 68.4187C48.5924 69.2397 49.1349 70.217 50.7237 69.9043C63.1262 65.8021 72 54.0742 72 40.2744C72 23.0031 58.1197 9 41 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitHub);
export default __webpack_public_path__ + "static/media/GitHub.1cd8eae337cfe9a3836f5b023eb3138e.svg";
export { ForwardRef as ReactComponent };